export const IBoFilterStatus = Object.freeze({
  code: "value",
  label: "text",
  criticity: "color",
  tooltip: "tooltip",
  key: "key",
});

export class BoFilterStatusModel {
  constructor(data = {}) {
    this[IBoFilterStatus.code] = data[IBoFilterStatus.code];
    this[IBoFilterStatus.label] = data[IBoFilterStatus.label];
    this[IBoFilterStatus.criticity] = data[IBoFilterStatus.criticity];
    this[IBoFilterStatus.tooltip] = data[IBoFilterStatus.tooltip];
    this[IBoFilterStatus.key] = data[IBoFilterStatus.key];
  }

  getCode() {
    return this[IBoFilterStatus.code];
  }

  getLabel() {
    return this[IBoFilterStatus.label];
  }

  getCriticity() {
    return this[IBoFilterStatus.criticity];
  }

  getTooltip() {
    return this[IBoFilterStatus.tooltip];
  }

  getKey() {
    return this[IBoFilterStatus.key];
  }
}
